/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { hsvaToHslaString } from './ColorUtils';
import DragEvent from './DragEvent';
import { Pointer } from './Pointer';

const Saturation = React.forwardRef((props, ref) => {
  const { prefixCls = 'saws-saturation', radius = 0, pointer, className, style, hsva, onChange, ...other } = props;

  const containerStyle = {
    width: 200,
    height: 200,
    borderRadius: radius,
    ...style,
    position: 'relative',
  };

  const handleChange = (interaction, event) => {
    onChange &&
      onChange({
        h: hsva.h,
        s: interaction.left * 100,
        v: (1 - interaction.top) * 100,
        a: hsva.a,
        // source: 'hsv',
      });
  };

  const comProps = {
    top: `${100 - hsva.v}%`,
    left: `${hsva.s}%`,
    color: hsvaToHslaString(hsva),
  };

  return (
    <DragEvent
      className={[prefixCls, className || ''].filter(Boolean).join(' ')}
      {...other}
      style={{
        position: 'absolute',
        inset: 0,
        cursor: 'crosshair',
        backgroundImage: `linear-gradient(0deg, #000, transparent), linear-gradient(90deg, #fff, hsl(${hsva.h}, 100%, 50%))`,
        ...containerStyle,
      }}
      ref={ref}
      onMove={handleChange}
      onDown={handleChange}
    >
      {React.createElement(pointer || Pointer, {
        prefixCls,
        fillStyle: {
          width: 6,
          height: 6,
          transform: 'translate(-3px, -3px)',
          boxShadow:
            'rgb(255 255 255) 0px 0px 0px 1.5px, rgb(0 0 0 / 30%) 0px 0px 1px 1px inset, rgb(0 0 0 / 40%) 0px 0px 1px 2px',
          borderRadius: '50%',
          backgroundColor: comProps.color,
        },
        ...comProps,
      })}
    </DragEvent>
  );
});

Saturation.displayName = 'Saturation';

export default Saturation;
